import { LoginField } from "..//components/LoginField";
import { useEffect, useState } from "react";
import RedirectBTN from "../components/RedirectBTN";
import { LoginButton } from "../components/LoginButton";
import { useTheme } from "../../../context/useThemeContext";
import useAccountManagementStore from "../../../stores/accountManagementStore";
import { useAccountManagementFunctions } from "../hooks/useAccountManagementFunctions";

export default function SignOutView() {
    const { theme } = useTheme();
    const [email, setEmail] = useState("");

    const { setLoginState, userData } = useAccountManagementStore(
        (state) => state,
    );
    const { signOut } = useAccountManagementFunctions();

    useEffect(() => {
        if (userData?.email !== undefined) {
            setEmail(userData?.email);
        } else {
            setEmail("");
        }
    }, [userData]);

    return (
        <form
            id="signOutForm"
            className="flex flex-col p-9 pb-7 text-center text-white"
            onSubmit={(e) => e.preventDefault()}
        >
            <b className="mb-4 text-2xl">Account Info</b>
            {/* Account type */}
            {/* <div className="flex space-x-2 text-sm pb-2">
                <p
                    style={{
                        color: theme.colors.gray[200],
                    }}
                >
                    Account type:
                </p>
                <p>Admin</p>
            </div> */}
            {/* Next Billing date */}
            {/* <div className="flex space-x-2 text-sm">
                <p
                    style={{
                        color: theme.colors.gray[200],
                    }}
                >
                    Next billing date:
                </p>
                <p>9/14/24</p>
            </div> */}

            {/* Form Fields */}
            <LoginField
                fieldID="email"
                fieldTitle="Email"
                fieldType="email"
                disabled={true}
                value={email}
                onChange={(e) => {
                    setEmail(e.target.value);
                }}
            />
            {/* Update Account Info */}
            <div className="flex w-full space-x-2 self-center text-sm">
                <RedirectBTN
                    name="Update Info"
                    onClick={() => {
                        setLoginState("updateAccount");
                    }}
                />
            </div>
            {/* Form Submit BTN */}
            <LoginButton
                type="submit"
                className="mb-1 mt-4 h-[36px] rounded text-sm"
                style={{
                    backgroundColor: theme.accentColor,
                }}
                onClick={signOut}
            >
                Sign Out
            </LoginButton>
        </form>
    );
}
